import Vue 							from 'vue'
import App 							from './App.vue'
import './registerServiceWorker'
import router 					from './router'
import store 						from './store'
import vuetify 					from './plugins/vuetify';
import * as VeeValidate from 'vee-validate'
import './ml'
import JsonExcel 				from 'vue-json-excel'
import VueGoogleCharts 	from 'vue-google-charts'
import axios 						from 'axios'
import '@/plugins/axios'
import VueAxios 				from 'vue-axios'
import DateRangePicker 	from 'vue2-daterange-picker'
// import 'leaflet/dist/leaflet.css';
import momentz 					from 'moment-timezone';
import moment 					from 'moment';
import EventBus 				from '@/event-bus'
import route			 			from '@/router/router'
import helper						from '@/helpers/helpers'
import Logos 						from '@/helpers/logos'
import format 					from '@/class/formats'
import support 					from '@/components/general_parameters/default_support.json'
import api 							from '@/api'
import sounds 					from '@/class/sounds'
import smart_events			from '@/class/smart_events'
import profile	 				from '@/class/dashboard/profile'
// import workspace  			from '@/class/workspace_class'
import record 					from '@/class/record_class'
import ws 							from '@/class/webSocket'
// import VueAnalytics 		from 'vue-analytics';
import VueGtag  				from 'vue-gtag'

// Syncfusion styles removed - not being used

Vue.config.productionTip = false

Vue.use(VueGoogleCharts)


// Timezones




momentz.locale('en');
let time_zone = momentz.tz.guess(); //`America/Bogota`;

if (localStorage.getItem('time_zone')) {
	time_zone = JSON.parse(localStorage.getItem('time_zone'));
}
// console.log("time gues : ", time_zone, momentz.tz.guess())
// momentz.tz(time_zone);
momentz.tz.setDefault(time_zone);//Asia/Ulaanbaatar //  America/Nassau // America/Bogota // Costa_Rica
// console.log( "timezone guess :",  momentz.tz.guess())

Vue.prototype.$timezone 			= time_zone;
Vue.prototype.$moment 				= moment;
Vue.prototype.$momentz 				= momentz;

// Requests
try{

	let user = helper.get_local('user');
	axios.defaults.withCredentials 	= 	false;
	if (user && user.jwt) {
		axios.defaults.headers.common["Authorization"] = `Bearer ${user.jwt}`;
		// axios.defaults.headers.common['CLIENT_IP'] = ""
	}
}catch(e){
	console.warn("Error convert json usr", e);
}
// axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';
// axios.defaults.headers.common['CLIENT_IP'] = api.ip + ':' + api.port;
// axios.defaults.baseURL = api.ip + ':' + api.port;
// axios.defaults.headers.common['X-DSI-RESTFUL'] = 1;
// axios.defaults.headers.common["ACCESS-CONTROL-EXPOSE-HEADERS"]  = "*";
Vue.prototype.$axios 						= 	axios;
Vue.prototype.$axiosReq 				= 	route; // Testing

// Connections
if (api) {
	let temp_sounds = new sounds(api.url); 	
	let log 				= false;

	log = helper.get_local("logs");
	
	let debug 		  = {
		logs : log,
	}; 
	helper.set_debug(debug.logs);

	// Format

	// setting format
	// create formats
	let urls = {
	  url  : api.url,
	  face : api.url_face,
	  ext  : api.ext,
	}
	let moments = {
	  momentz : momentz,
	  moment  : moment
	}
	// set class to variable global
	let temp_devices 	= helper.get_local('list_devices');
	let devs 					= [];
	if (temp_devices) {
		devs = temp_devices;	
	}

	// set Format
	let temp_format 			=  new format(urls, null, moments, {}, store, debug, helper, axios, api);
	temp_format.update_list('devices', devs);
	Vue.prototype.$Format = temp_format;

	//config socket io
	Vue.prototype.$setting_socket = {
		//"path" : "/ws",
		"transport"     		: ['websocket'],	
		"pingTimeout"   		: 5000,
		"reconnection"  		: true,
		"reconnect" 				: false, 
		"timeout" 					: 15000, // Increased timeout
		"reconnectionDelay" : 5000,
		"pingInterval" 			: 10000, // Aumenta la frecuencia de los pings (en milisegundos)
		"withCredentials"     : false,
		"forceNew" 				: true, // Force new connections to avoid conflicts
		"autoConnect" 			: true, // Don't auto-connect, let components handle it
		
       
  
		 // forceNew: true 
	}


	Vue.prototype.$API 							=   api;
	Vue.prototype.$localhost 				=   api.ip;
	Vue.prototype.$localsocket 			=   api.ip_socket; 
	Vue.prototype.$port 						= 	api.port;
	Vue.prototype.$port_socket			=	 	api.port_socket;
	Vue.prototype.$port_face				=		api.port_face;
	// Vue.prototype.$namespace 				= 	api.workspace;
	Vue.prototype.$protocol 				= 	api.protocol;
	Vue.prototype.$protocol_socket 	= 	api.protocol_socket;
	Vue.prototype.$URL 							= 	api.url;
	Vue.prototype.$URL_face 				=  	api.url_face;
	Vue.prototype.$is_docker 				= 	api.isdocker;
	Vue.prototype.$EXT 							=  	api.ext;
	Vue.prototype.$Sounds 					=   temp_sounds;
	Vue.prototype.$SmartEvent 			= 	new smart_events(api, axios, helper);
	Vue.prototype.$Debug						= 	debug;
	Vue.prototype.$Profile					=		new profile(api, axios, helper);	
	// Initialize PDF class with lazy loading
	Vue.prototype.$Pdf = null;
	Vue.prototype.$loadPdf = async () => {
		if (!Vue.prototype.$Pdf) {
			const pdfModule = await import('@/class/pdf');
			Vue.prototype.$Pdf = new pdfModule.default(api, axios, helper);
		}
		return Vue.prototype.$Pdf;
	};
	Vue.prototype.$Record  					=   new record(api, axios, EventBus);
	Vue.prototype.$WS  							= 	new ws({
			api,
			axios,
			helper,
			EventBus,
			store,
			format 		: temp_format,
			settings 	:	Vue.prototype.$setting_socket,
	});
	Vue.prototype.$Format.update_list("WS", Vue.prototype.$WS);
	Vue.prototype.$Format.update_list("EventBus", EventBus);
	
	// record.set_var("test", "test")
	
	// Vue.prototype.$Workspaces				= 	new workspace(api, axios, helper, EventBus);


	// setting logos
	let LOGOS 				= new Logos(api.url, api.ext, axios);
	let images_logos 	= LOGOS.get_logos();
	if (!images_logos) {
		images_logos 		= LOGOS.default();
		// console.log("logo default ", images_logos)
	}


	/*	const favicon = document.getElementById("favicon");
		console.log("logo favicon : ",favicon)
		favicon.href = 'http://localhost:9090/uploads/file-1627573891426-logo_night.png';//"https://www.google.com/favicon.ico";

	*/


	Vue.prototype.$logos = images_logos;

	axios.get(api.protocol + "//" + api.ip + ":" + api.port + "/api/v1/parameter/" + 1).then(ress => {
		if (ress && ress.data) {
			Vue.prototype.$Format.update_list("PARAMETERS", { ...ress.data });
			helper.set_local('PARAMETERS', ress.data);
			if (ress.data.timezone) {
				let timeZ = ress.data.timezone;
				if (timeZ != time_zone) {			
					momentz.tz.setDefault(timeZ);
					Vue.prototype.$momentz 	= momentz;
					Vue.prototype.$timezone = timeZ;
					moments.momentz 				= momentz;
					helper.set_local('time_zone', timeZ);
					Vue.prototype.$Format.update_list('timezone', timeZ);
					// Vue.prototype.$Format.update_list('ml', moments);
					// Vue.prototype.$Format 	= temp_format;
				}
			}
			if (ress.data.server_rtsp) {
				Vue.prototype.$server_rtsp = ress.data.server_rtsp;
			}
			if (ress.data.analytic_google_id) {
				/*Vue.use(VueAnalytics, {
				  id: ress.data.google_analytic_id,// 'UA-127508299-1'
				  router
				});*/
				Vue.use(VueGtag, {
				  config: { id: ress.data.google_analytic_id }
				});
				Vue.prototype.$google_analytic = ress.data.google_analytic_id;	
			}else{
				/*if (location && location.hostname && location.hostname.includes("demo")) {
					Vue.use(VueAnalytics, {
					  id: 'UA-127508299-1', 
					  router
					});
				}*/
			}
		}else{
			let parameters = helper.get_local('PARAMETERS');
			if (parameters) {
				Vue.prototype.$Format.update_list("PARAMETERS", { ...parameters });
			}
		}
	}).catch( err => {
		// console.log("err get timezone", err)
		let parameters = helper.get_local('PARAMETERS');
		if (parameters) {
			Vue.prototype.$Format.update_list("PARAMETERS", { ...parameters });
		}
	})

}else{
	// console.warn("!Urgent required setting API ", api);
}


// ConnectionBus
Vue.prototype.$EventBus 	  		=  	EventBus;	// Testing



// List 
Vue.prototype.$Devices 				 	= [];
Vue.prototype.$Constellations 	= [];

// helpers
Vue.prototype.$Helper 		= helper; 

// confidence face
Vue.prototype.$confidence = 0.1;

// setting support
let temp_support = helper.get_local('setting_support');
if (!temp_support) {
	temp_support  		 = support;
	const support_save = helper.set_local('setting_support', support);
}

Vue.prototype.$settings_support = temp_support;

let version 		 = "AG-1.1.2"; // AG-1.0.1

let temp_version = helper.get_local("AG_version");
let up_version 	 = {
	version,
	date : new Date(),
};
if (temp_version) {
	if (temp_version.version != version) {

		helper.set_local("AG_version", up_version)
	}
}else{
	helper.set_local("AG_version", up_version)
}
Vue.prototype.$Version_AG = `V ${version}, `;
// console.log("*****************************************\n VERSION : ", temp_version)


Vue.use(VeeValidate);

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
